// Analytics utility - loads GA4 only after initial page render
// This prevents GA4 from blocking the critical rendering path

import { getConfig } from '../config/environment';

let gaInitialized = false;

export const initializeAnalytics = () => {
  const { gaTag, isSocialBot } = getConfig();
  
  if (gaInitialized || isSocialBot === true) {
    return;
  }

  gaInitialized = true;

  // Add custom transport
  const customTransport = {
    send: (url, data) => {
      return fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache'
        },
        credentials: 'same-origin'
      }).catch(() => {});
    }
  };

  // Dynamically import GA4 after initial render
  import('react-ga4').then(ReactGA => {
    ReactGA.default.initialize(gaTag, {
      transport: customTransport,
      gaOptions: {
        cookieFlags: 'SameSite=Strict;Secure',
        anonymizeIp: true,
        storage: 'none',
        storeGac: false,
        storage_type: 'localStorage'
      }
    });

    ReactGA.default.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: document.title,
      clientId: localStorage.getItem('ga_client_id')
    });
  }).catch(error => {
    console.error('Failed to load analytics:', error);
  });
};

export const trackPageView = (pathname, search) => {
  const { isSocialBot } = getConfig();
  
  if (!gaInitialized || isSocialBot === true) {
    return;
  }

  import('react-ga4').then(ReactGA => {
    ReactGA.default.send({
      hitType: "pageview",
      page: pathname + (search || ''),
      title: document.title,
      clientId: localStorage.getItem('ga_client_id')
    });
  }).catch(() => {
    // Silently fail - analytics is not critical
  });
};
